import React from "react"
import { Layout, SEO, FullTestimonial, Mission } from "../components";

const TestimonialPage = () => (
  <Layout>
    <div className="pgabt pgtsmnl">
      <SEO title="Testimonials - Natural Silver Solutions | Professional Bio-Active colloidal silver supplement" description="Natural Silver Solutions. Professional Bio-Active colloidal silver supplement, delivers advantages no other manufacturer can match"/>
      <FullTestimonial/>
      <Mission/>
    </div>
  </Layout>
)

export default TestimonialPage
